import { Link } from "react-router-dom";
import { API } from "../lib/api";
import { useCart } from "../context/CartContext";
import { ShoppingCart, Zap, Star } from "lucide-react";
import { toast } from "sonner";

export const fmtRON = (v) => `${new Intl.NumberFormat("ro-RO").format(v)} RON`;
export const imgUrl = (path) => (path ? `${API}/shop/images/${path}` : null);

export const ProductCard = ({ product }) => {
  const { add } = useCart();
  const img = imgUrl((product.images || [])[0]?.path);
  const out = product.stock <= 0;
  return (
    <div data-testid={`product-card-${product.id}`}
      className="group relative bg-[#0B0B0B] border border-[#00E5FF]/15 hover:border-[#00E5FF]/50 transition-colors flex flex-col">
      {product.featured && (
        <div className="absolute top-3 left-3 z-10 bg-[#00E5FF] text-black text-[10px] uppercase tracking-widest font-bold px-2 py-1 flex items-center gap-1">
          <Zap className="w-3 h-3" fill="currentColor" /> Top
        </div>
      )}
      {product.old_price > 0 && product.old_price > product.price && (
        <div className="absolute top-3 right-3 z-10 bg-[#FF0044] text-white text-[10px] uppercase tracking-widest font-bold px-2 py-1">
          -{Math.round((1 - product.price / product.old_price) * 100)}%
        </div>
      )}
      <Link to={`/produs/${product.id}`} data-testid={`product-link-${product.id}`} className="block aspect-square overflow-hidden bg-[#101010]">
        {img ? (
          <img src={img} alt={product.name} loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#00E5FF]/20">
            <Zap className="w-16 h-16" />
          </div>
        )}
      </Link>
      <div className="p-5 flex flex-col flex-1">
        <Link to={`/produs/${product.id}`} className="font-display text-sm uppercase leading-snug hover:text-[#00E5FF] transition-colors">{product.name}</Link>
        {product.rating_count > 0 && (
          <div className="flex items-center gap-1.5 mt-1.5">
            <span className="inline-flex gap-0.5">
              {[1, 2, 3, 4, 5].map((i) => (
                <Star key={i} className={`w-3 h-3 ${i <= Math.round(product.rating_avg) ? "text-[#00E5FF]" : "text-neutral-700"}`}
                  fill={i <= Math.round(product.rating_avg) ? "currentColor" : "none"} />
              ))}
            </span>
            <span className="text-[10px] text-neutral-500">({product.rating_count})</span>
          </div>
        )}
        {product.short_desc && <div className="text-xs text-neutral-500 mt-1.5 line-clamp-2">{product.short_desc}</div>}
        {(product.compatible_models || []).length > 0 && (
          <div data-testid={`compat-badges-${product.id}`} className="flex flex-wrap gap-1 mt-2">
            {product.compatible_models.slice(0, 3).map((m) => (
              <span key={m} className="text-[9px] uppercase tracking-wide border border-[#00E5FF]/25 text-[#00E5FF]/80 px-1.5 py-0.5">{m}</span>
            ))}
            {product.compatible_models.length > 3 && (
              <span className="text-[9px] text-neutral-500 px-1 py-0.5">+{product.compatible_models.length - 3}</span>
            )}
          </div>
        )}
        <div className="mt-auto pt-4 flex items-end justify-between gap-2">
          <div>
            {product.old_price > 0 && product.old_price > product.price && (
              <div className="text-xs text-neutral-500 line-through">{fmtRON(product.old_price)}</div>
            )}
            <div className="text-[#00E5FF] font-bold text-lg leading-none">{fmtRON(product.price)}</div>
          </div>
          <button data-testid={`add-to-cart-${product.id}`} disabled={out}
            onClick={() => { add(product); toast.success(`${product.name} adaugat in cos`); }}
            className={`p-2.5 transition-colors ${out ? "bg-neutral-900 text-neutral-600 cursor-not-allowed" : "bg-[#00E5FF] text-black hover:bg-[#5CEEFF]"}`}>
            <ShoppingCart className="w-4 h-4" />
          </button>
        </div>
        <div className={`text-[10px] uppercase tracking-widest mt-2 ${out ? "text-red-400" : "text-green-400"}`}>
          {out ? "Stoc epuizat" : "In stoc"}
        </div>
      </div>
    </div>
  );
};
